__webpack_require__.p = "//res-static.inframe.mobi/user/";